import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    redirect: '/dashboard'
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('@/components/pages/DashboardPage.vue'),
    meta: { title: '工作台' }
  },
  {
    path: '/works',
    name: 'works',
    component: () => import('@/components/pages/WorksPage.vue'),
    meta: { title: '我的作品' }
  },
  {
    path: '/materials',
    name: 'materials',
    component: () => import('@/components/pages/MaterialsPage.vue'),
    meta: { title: 'AI素材库' }
  },
  {
    path: '/promotion',
    name: 'promotion',
    component: () => import('@/components/pages/PromotionPage.vue'),
    meta: { title: '推广分享' }
  },
  {
    path: '/member',
    name: 'member',
    component: () => import('@/components/pages/MemberPage.vue'),
    meta: { title: '会员中心' }
  },
  {
    path: '/account',
    name: 'account',
    component: () => import('@/components/pages/AccountPage.vue'),
    meta: { title: '我的账号' }
  },
  {
    path: '/workspace/:id',
    name: 'workspace',
    component: () => import('@/components/pages/WorkspacePage.vue'),
    meta: { title: '作品空间' },
    props: true
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

// Update document title on navigation
router.afterEach((to) => {
  document.title = (to.meta.title ? to.meta.title + ' - ' : '') + '橙子AI创作平台'
})

export default router
